import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ChangeDetectorRef, Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { finalize, interval, Subscription, take } from 'rxjs';

import { FilledInputDirective } from '@shared/directives/filledInput.directive';
import { AuthService } from '@app/features/auth/services/auth.service';
import { Spinner } from '@shared/components/spinner/spinner';
import { Utility } from '@common/utility';

@Component({
  selector: 'app-change-password',
  imports: [CommonModule, RouterModule, ReactiveFormsModule, FormsModule, FilledInputDirective , Spinner , NgOptimizedImage],
  providers: [AuthService, Utility],
  templateUrl: './change-password.html',
  styleUrl: './change-password.scss'
})
export class ChangePassword implements OnInit {
  resetForm: FormGroup;
  showPassword = false;
  showConfirmPassword = false;
  loader = signal(false);
  isForgotPassword: boolean = false;
  token : any;
  email : any;
  tokenExpireError : string =''
  constructor(
    private fb: FormBuilder, 
    private authService: AuthService,
     private cdr: ChangeDetectorRef, 
     public utility: Utility,
     private route: ActivatedRoute,
     private router :Router
    ) {
    this.resetForm = this.fb.group({
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    })
  }
  ngOnInit(): void {
   this.token = this.route.snapshot.queryParamMap.get('token')
   this.email = this.route.snapshot.queryParamMap.get('email')
  }
  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }
  toggleConfirmPassword(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
  onSubmit() {
    const payload = {
       token : this.token,
       email : this.email,
       password : this.resetForm.get('newPassword')?.value,
       password_confirmation : this.resetForm.get('confirmPassword')?.value
    }
    this.loader.set(true)
   this.authService.resetPassword(payload).pipe(finalize(()=> {
    this.loader.set(false)
    this.cdr.detectChanges();
   })).subscribe({
    next: (res) => {
      if(res.success === true){
      this.router.navigate(['/login']);
      }
      },
      error: (err) => {
        this.mapErrors(err?.error?.errors);
        this.tokenExpireError = err?.error?.errors?.token[0]
        this.cdr.detectChanges();
      },
   })
  }
   mapErrors(json: any) : void {
    if (json?.password) {
      this.resetForm.get('newPassword')?.setErrors({ serverError: json.password[0] })
    }
    if (json?.password_confirmation) {
      this.resetForm.get('confirmPassword')?.setErrors({ serverError: json.password_confirmation })
    }
  }
}
